import { render, staticRenderFns } from "./GapCard.vue?vue&type=template&id=1446785c&scoped=true"
import script from "./GapCard.vue?vue&type=script&lang=js"
export * from "./GapCard.vue?vue&type=script&lang=js"
import style0 from "./GapCard.vue?vue&type=style&index=0&id=1446785c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1446785c",
  null
  
)

export default component.exports